import { render, staticRenderFns } from "./couponsList.vue?vue&type=template&id=78a4ffd2"
import script from "./couponsList.vue?vue&type=script&lang=js"
export * from "./couponsList.vue?vue&type=script&lang=js"
import style0 from "./couponsList.vue?vue&type=style&index=0&id=78a4ffd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports